import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" This is the number of transactions you've sent over the past 7 days. Are you cookin', cruisin', or crawlin'? ")
const _hoisted_2 = {
  class: "flex flex-1",
  style: {"min-height":"250px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!
  const _component_DashboardCard = _resolveComponent("DashboardCard")!

  return (_openBlock(), _createBlock(_component_DashboardCard, {
    class: "col-span-2 xl:col-span-1 order-7 md:order-none",
    title: "Weekly Transaction Rate",
    embed: "embed:transaction-rate"
  }, {
    help: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Chart, {
          class: "chart flex-shrink",
          option: _ctx.weeklyTransactionRateOption,
          autoresize: ""
        }, null, 8, ["option"])
      ])
    ]),
    _: 1
  }))
}